export const EVENTS = 'EVENTS';
export const BOOK_EVENT = 'BOOK_EVENT';
export const IKEA_FAMILY_ONLY = 'IKEA_FAMILY_ONLY';
export const IKEA_BUSINESS_NETWORK_ONLY = 'IKEA_BUSINESS_NETWORK_ONLY';
export const FREE_FOR_ALL = 'NO_RESTRICTIONS';
export const FREE_FOR_ALL_BUSINESS = 'NO_RESTRICTIONS_BUSINESS';
export const DIGITAL = 'DIGITAL';
export const PHYSICAL = 'PHYSICAL';
export const CANCELLED = 'REMOVED';
export const ACTIVE = 'ACTIVE';

export enum userAuthStates {
  NOT_LOGGED_IN = 'NOT_LOGGED_IN',
  LOGGED_IN_AS_FAMILY = 'LOGGED_IN_AS_FAMILY',
  LOGGED_IN_AS_REGULAR = 'LOGGED_IN_AS_REGULAR',
  LOGGED_IN_AS_BUSINESS_NETWORK = 'LOGGED_IN_AS_BUSINESS_NETWORK',
}
